define('controllers/resethotelpassword',['require'],function(require) {
    return function () {
        var hotelId = window.ServerData.feData.hotelId;
        var defaultPassword = window.ServerData.feData.defaultPassword;
        //reset password
        var btnResetPW = $("#btnResetPW"),
            txtEmail = $("#txtEmail");

        btnResetPW.on("click", function () {
            var portalUserNameResetPW = $("#portalUserNameResetPW"),
                msg = btnResetPW.next(),
                email = txtEmail.val().trim().toLowerCase(),
                userName = portalUserNameResetPW.val().trim();

            if (userName != "") {
                if (email != "") {
                    //come back with error if email not sent...
                    btnResetPW.prop('disabled', true);
                    $.post("ResetHotelPasswordAJAX.aspx", { method: "ResetPassword", email: email, username: userName, hotelId: hotelId }, function (response) {
                        Utilities.handleAJAXResponse(response, function (success) {
                            Utilities.setInfo("Successfully reset password and sent credentials.", msg);
                        },
                        function (error) {
                            Utilities.setError(error, msg);
                        });
                    }).complete(function () { btnResetPW.prop('disabled', false); });
                } else {
                    Utilities.setError("Please enter an email for the reset password email to go to.", msg);
                }
            } else {
                Utilities.setError("Please enter the username of the hotel portal you'd like to reset.", msg);
            }
        });

        //create new portal
        var btnCreateNewPortal = $("#btnCreateNewPortal"),
            createNewPortalUserForm = $("#createNewPortalUserForm");

        $("#createNewPortalUserForm input[name='password']").val(defaultPassword);

        btnCreateNewPortal.on("click", function () {
            var portalFormBoxes = $("input, select, textarea", createNewPortalUserForm),
                valuesArray = portalFormBoxes.serializeArray(),
                msg = btnCreateNewPortal.next();

            for (var i = 0; i < valuesArray.length; i++) {
                var value = valuesArray[i];
                if (value.value.trim() == "" && value.name != "password") { //don't require password
                    Utilities.setError("You must provide a value for " + value.name, msg);
                    return false;
                }
            }

            btnCreateNewPortal.prop('disabled', true);
            var extraVals = "&method=CreatePortal&hotelId=" + hotelId;
            $.post("ResetHotelPasswordAJAX.aspx", portalFormBoxes.serialize() + extraVals, function (response) {
                Utilities.handleAJAXResponse(response, function (success) {
                    Utilities.setInfo(success.info + "<br /><br />Please notify whoever this portal was created for (the email that was pluggged in).", msg);
                },
                function (error) {
                    Utilities.setError(error, msg);
                });
            }).complete(function () { btnCreateNewPortal.prop('disabled', false); });
        });

        txtEmail.focus();
        Utilities.setDefaultButton($("#resetForm"), btnResetPW);
        Utilities.setDefaultButton(createNewPortalUserForm, btnCreateNewPortal);
    };
});

